import { EnvioViewModel } from './envioViewModel';

export class ListadoEnvios {
    envios: Array<EnvioViewModel>;
    total: number;
    prevLink: string;
    nextLink: string;
}



// WEBPACK FOOTER //
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/app/models/viewmodels/listadoEnvios.ts